export function processLiveChatStartAction(response, almeState, setAlmeState) {
    if (!almeState.isLiveChatConnected && (response === null || response === void 0 ? void 0 : response.responseActions)) {
        for (const action of response.responseActions) {
            if (action.Name === "LiveChatStart") {
                setAlmeState(Object.assign(Object.assign({}, almeState), { isLiveChatConnected: true }));
                return;
            }
        }
    }
}
